import WrappedLoginMobileForm from './views/LoginView';

export default WrappedLoginMobileForm;